import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import StickyFooter from "../components/StickyFooter/StickyFooter";
import PermanentDrawer from "../components/PermanentDrawer/PermanentDrawer";
import TeachingDashboard from "../components/Dashboard/TeachingDashboard/Page";

const Home = () => {
  return (
    <>
      <Header />
      <PermanentDrawer children={<TeachingDashboard />} />
      <StickyFooter />
    </>
  );
};

export default Home;
